import { Component } from 'react';

class JoinLeagueMpdal extends Component {
  render() {
    return <div>JoinLeagueMpdal</div>;
  }
}

export default JoinLeagueMpdal;
